import React from "react";
import "./LeftDrawer.scss"
import close from "../../assets/close.svg"
import Button from "../Button/Button";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";

const LeftDrawer = ({ isOpen, setIsOpen }) => {

    const history = useHistory()
    const dispatch = useDispatch()
    const companyDetails = useSelector((state) => state.companyData.companyDetails);

    const pages = useSelector((state) => state.companyData.pages)

    const page = pages?.find((page) => page.PageId === "navbar")

    const linksComponent = page?.Components?.find((component) => component?.ID === "PapayaNavbar-Navbar-link")?.Data ?? []
    const buttonComponent = page?.Components?.find((component) => component?.ID === "PapayaNavbar-Navbar-button")?.Props ?? null

    return (
        <div className="PapayaLeftDrawer">
            <div className={`PapayaLeftDrawer-left-drawer ${isOpen ? 'open' : ''}`}>
                <div className={`PapayaLeftDrawer-left-drawer-header`}>
                    <img alt="" src={close}
                        onClick={() => {
                            setIsOpen(false)
                        }} />
                </div>
                <div className={`PapayaLeftDrawer-left-drawer-content`}>
                    {linksComponent.map((page, key) => {
                        return (
                            <>
                                <div className={`PapayaLeftDrawer-left-drawer-content-pages  ${window.location.pathname === page?.href ? "PapayaLeft-link-selected " : ""}`} key={key}
                                    onClick={() => {
                                        setIsOpen(false)
                                        if (page?.href) {
                                            if (page?.href?.includes("https://")) {
                                                if (page?.href && page?.href !== "") {
                                                    window.open(page?.href, '_blank')
                                                }
                                                else {
                                                    dispatch(setIsComing(true))

                                                }
                                            } else {
                                                history.push(page?.href)
                                            }
                                        } else {
                                            dispatch(setIsComing(true))
                                        }

                                    }}>
                                    {page?.title}

                                </div>
                            </>
                        )
                    })}
                    {buttonComponent && <div className={`PapayaLeftDrawer-left-drawer-content-btn`}>

                        <Button
                            text={buttonComponent?.buttonText}
                            onClick={() => {
                                if (buttonComponent?.href && buttonComponent?.href !== "") {
                                    window.open(buttonComponent?.href, '_blank')
                                } else {
                                    dispatch(setIsComing(true))
                                }
                            }}
                            isPrimary={false} />
                    </div>}
                </div>
                <div className="PapayaLeftDrawer-left-drawer-bottm">
                    <div className="PapayaLeftDrawer-left-drawer-bottm-header">
                        ADDRESS
                    </div>
                    <div className="PapayaLeftDrawer-left-drawer-bottm-item">
                        {companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}
                    </div>
                    <div className="PapayaLeftDrawer-left-drawer-bottm-item2">
                        P: <b> {companyDetails?.contactNumber}</b>
                    </div>
                    <div className="PapayaLeftDrawer-left-drawer-bottm-item2">
                        E: <b> {companyDetails?.email}</b>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default LeftDrawer